<template>
  <article :id="$vnode.key">
    <custom-callout
      ref="callout"
      :has-toggle="true"
      :controlled="true"
      :opened="isOpen"
      class="mt-2 mb-3"
      @click:open="
        () => {
          reasonPanelMode = -1;
          toggleCallout();
        }
      "
    >
      <template #default>
        <div class="row py-3 pr-4" :style="{ 'min-height': '140px' }">
          <div
            class="col-sm-12 col-md-3 col-lg-2 py-3 border-right-2 d-flex flex-column align-items-start justify-content-start"
            style="position: relative; bottom: 5px"
          >
            <custom-balloon
              class="px-4 p-2 mt-3 text-body"
              :text="item.referralStatusName"
              :background-color="getStatusColor(item.referralStatusId)"
              dot
            />
            <div class="mt-2">
              <span
                class="color-gray font-weight-normal font-14"
                v-text="'Servicio:'"
              />
            </div>
            <div class="mt-2">
              <b>{{ item.evaluationTypeName }}</b>
              <p>{{ item.disciplineTypeName }}</p>
            </div>
          </div>
          <div class="col mt-2 mt-lg-0">
            <div class="row">
              <div class="col-12 col-sm-6 col-lg-3 mt-2 mt-lg-1">
                <div class="regular text-gray">Nombre:</div>
                <span
                  class="regular font-weight-bold"
                  v-text="item.studentFullName"
                />
              </div>
              <div class="col-12 col-sm-6 col-lg-3 mt-2 mt-lg-1">
                <div class="regular text-gray">SIE:</div>
                <span
                  class="regular font-weight-bold"
                  v-text="item.studentSieId"
                />
              </div>
              <div class="col-12 col-sm-6 col-lg-3 mt-2 mt-lg-1">
                <div class="regular text-gray">Fecha de solicitud:</div>
                <span
                  class="regular font-weight-bold"
                  v-text="item.requestDate"
                />
              </div>
              <div class="col-12 col-sm-6 col-lg-3 mt-2 mt-lg-1">
                <div class="regular text-gray">Impedimento:</div>
                <span
                  class="regular font-weight-bold"
                  v-text="item.studentImpediment"
                />
              </div>
              <div class="col-12 mt-2 d-none d-lg-block" />
              <div class="col-12 col-sm-6 col-lg-6 mt-2 mt-lg-1">
                <div class="regular text-gray">Escuela:</div>
                <span
                  class="regular font-weight-bold"
                  v-text="item.studentSchool"
                />
              </div>
              <div class="col-12 col-sm-6 col-lg-3 mt-2 mt-lg-1">
                <div class="regular text-gray">Solicitado por:</div>
                <span
                  class="regular font-weight-bold"
                  v-text="item.createByFullName"
                />
                <br />
                <span
                  class="regular font-weight-bold"
                  v-text="item.createDate"
                />
              </div>
              <div class="col-12 col-sm-6 col-lg-3 mt-2 mt-lg-1">
                <div class="regular text-gray">Citas Canceladas:</div>
                <span
                  class="regular font-weight-bold"
                  v-text="item.appointmentCanceledCount"
                />
              </div>
              <div class="col-12 mt-2 d-none d-lg-block" />
              <div class="col-12 col-sm-6 col-lg-12 mt-2 mt-lg-1">
                <div class="regular text-gray">Razón del Referido:</div>
                <span
                  class="regular font-weight-bold"
                  v-text="item.referralRequestReason || '-'"
                />
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-2 mt-2 mt-lg-0">
            <div class="text-right">
              <dropdown
                v-if="actionItems(item).length > 0"
                :key="`${item.studentReferralId}-${item.referralStatusId}`"
                :items="actionItems(item)"
              />
            </div>
          </div>
        </div>
      </template>
      <template #edition>
        <div class="bg-gray p-2">
          <div class="bg-white rounded">
            <b-tabs
              ref="resultTabs"
              :no-nav-style="true"
              content-class="mt-3"
              nav-class="custom-nav-container"
            >
              <b-tab
                v-if="
                  reasonPanelMode == -1 &&
                    !isReactivation &&
                    !isEditRejectReazon
                "
                active
                lazy
                title="Información de contacto"
                class="bg-white"
              >
                <div
                  class="p2 mt-1 col-12 custom-row-information-collapse bg-white rounded"
                >
                  <div class="row pl-sm-0 pl-md-4 pl-lg-4">
                    <div
                      class="col col-sm-12 detail-title pt-4 d-flex flex-row justify-content-start align-items-center"
                    >
                      <i class="fas fa-info-circle text-orange" />
                      <b>Información de contacto</b>
                    </div>
                  </div>
                  <div class="row additional-info pb-3 py-4">
                    <div class="col-sm-12 col-md-3 col-lg-3">
                      <label>Nombre:</label>
                      <br />
                      <p>
                        {{ student.contactName }}
                      </p>
                    </div>
                    <div class="col-sm-12 col-md-3 col-lg-3">
                      <label>Parentesco:</label>
                      <br />
                      <p>
                        {{ student.contactRelationName }}
                      </p>
                    </div>
                    <div class="col-sm-12 col-md-3 col-lg-3">
                      <label>Correo electrónico:</label>
                      <br />
                      <p>
                        {{ student.contactEmail }}
                      </p>
                    </div>
                    <div class="col-sm-12 col-md-3 col-lg-3">
                      <label>Teléfono:</label>
                      <br />
                      <p>{{ student.contactTelephone | phone }}</p>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab
                v-if="reasonPanelMode == -1 && isVocationalEducation"
                lazy
                title="Información de Escuela"
              >
                <div
                  class="p2 mt-1 col-12 custom-row-information-collapse bg-white rounded"
                >
                  <div class="row pl-sm-0 pl-md-4 pl-lg-4">
                    <div
                      class="col col-sm-12 detail-title pt-4 d-flex flex-row justify-content-start align-items-center"
                    >
                      <i class="fas fa-info-circle text-orange" />
                      <b>Información de Escuela</b>
                    </div>
                  </div>
                  <div class="row additional-info pb-3 py-4">
                    <div class="col-sm-12 col-md-3 col-lg-3">
                      <label>Nombre de contacto:</label>
                      <br />
                      <p>
                        <b>{{ schoolInfo.schoolName }}</b>
                      </p>
                    </div>
                    <div class="col-sm-12 col-md-3 col-lg-3">
                      <label>Posición:</label>
                      <br />
                      <p>
                        <b>{{ schoolInfo.schoolPositionName }}</b>
                      </p>
                    </div>
                    <div class="col-sm-12 col-md-3 col-lg-3">
                      <label>Teléfono:</label>
                      <br />
                      <p>
                        <b>{{ schoolInfo.schoolPhone }}</b>
                      </p>
                    </div>
                    <div class="col-sm-12 col-md-3 col-lg-3">
                      <label>Correo electrónico:</label>
                      <br />
                      <p>
                        <b>{{ schoolInfo.schoolEmail }}</b>
                      </p>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab v-if="isReactivation" lazy title="Razón">
                <ReactivationForm
                  @reactivate="handleReactivate"
                  @cancel="handleCancelReactivate"
                />
              </b-tab>
              <b-tab v-if="isEditRejectReazon" lazy title="Razón">
                <RejectionReasonForm
                  :student-referral-id="item.studentReferralId"
                  :reject-option-id="item.referralDenialReasonId"
                  :reject-comment="item.referralDeterminationComment"
                  :reject-document-id="item.documentId"
                  :reject-document-name="item.documentName"
                  @confirm="handleEditRejectReazon"
                  @cancel="handleCancelEditRejectReazon"
                />
              </b-tab>
              <b-tab
                v-if="item.showCoordinateAppointment"
                lazy
                title="Cita Coordinada"
              >
                <div
                  v-if="item.showCoordinateAppointment"
                  class="col-12 px-1 pt-2 mt-1 bg-gray-9 rounded"
                >
                  <div class="bg-white rounded p-3">
                    <coordinate-appointment
                      :discipline-type-id="item.disciplineTypeId"
                      :service-id="item.serviceTypeId"
                      :student-sie-id="item.studentSieId"
                      :student-referral-id="item.studentReferralId"
                      @on-save="
                        (appointment) =>
                          onSaveCoordinateAppointment(item, appointment)
                      "
                      @on-cancel="
                        () => onCancelCoordinateAppointmentPanel(item)
                      "
                    />
                  </div>
                </div>
              </b-tab>
              <b-tab
                lazy
                v-if="
                  hasAditionalInformation &&
                    !isReactivation &&
                    !isEditRejectReazon
                "
                :title="getAdditionalInfoTitle(item.referralStatusId)"
              >
                <div class="additional-container">
                  <div
                    v-if="reasonPanelId == item.studentReferralId"
                    class="p2 mt-1"
                  >
                    <div class="bg-gray rounded p-2">
                      <div class="col-12 p-0 bg-white rounded">
                        <EvaluationReasons
                          :referral-status="reasonPanelMode"
                          :student-referral-id="item.studentReferralId"
                          :old-referral-status="item.referralStatusId"
                          @cancel="onCancelReferalPanel"
                          @changestatus="onChangeStudentStatus"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="attachDocumentPanelId == item.studentReferralId"
                    class="p2 mt-1"
                  >
                    <div class="bg-gray rounded p-2">
                      <div class="col-12 p-0 bg-white rounded">
                        <AttachDocument
                          :student-sie="item.studentSieId"
                          :referral-status="reasonPanelMode"
                          :student-referral-id="item.studentReferralId"
                          @cancel="onCancelReferalPanel"
                          @changestatus="onChangeStudentStatus"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      hasAditionalInformation(item.referralStatusId) &&
                        !attachDocumentPanelId &&
                        !reasonPanelId
                    "
                    :id="'collapseRow' + item.index"
                    class="p2 mt-1 col-12 custom-row-information-collapse bg-white rounded"
                  >
                    <div class="row pl-sm-0 pl-md-4 pl-lg-4">
                      <div
                        class="col col-sm-12 detail-title pt-4 d-flex flex-row justify-content-start align-items-center"
                      >
                        <i class="fas fa-info-circle text-orange" />
                        <b>
                          {{ getAdditionalInfoTitle(item.referralStatusId) }}
                        </b>
                      </div>
                    </div>
                    <div
                      v-if="
                        item.referralStatusId ==
                          referralStatusEnum.AprobadoEnRempro
                      "
                      class="row additional-info pb-3 py-4"
                    >
                      <div class="col-sm-12 col-md-3 col-lg-3">
                        <label>Fecha de la solicitud:</label>
                        <br />
                        <b>{{ item.requestProvisionalDate }}</b>
                      </div>
                      <div class="col-sm-12 col-md-3 col-lg-3">
                        <label>Número de Solicitud:</label>
                        <br />
                        <b>{{ item.requestNumberRemPro }}</b>
                      </div>
                      <div class="col-sm-12 col-md-3 col-lg-3">
                        <label>Estatus de Servicio:</label>
                        <br />
                        <b>{{ item.serviceStatusDesc }}</b>
                      </div>
                      <div class="col-sm-12 col-md-3 col-lg-3">
                        <label>Contrato:</label>
                        <br />
                        <b>
                          {{ item.contractNumber }}
                          <br />
                          {{ item.contractStatusDesc }}
                        </b>
                      </div>
                      <div class="col-sm-12 col-md-3 col-lg-3">
                        <label>Fecha de Evaluación:</label>
                        <br />
                        <b>{{ item.contractEvaluationDate }}</b>
                      </div>
                    </div>
                    <div
                      v-if="
                        item.referralStatusId == referralStatusEnum.Denegado ||
                          item.referralStatusId == referralStatusEnum.Inactivo
                      "
                      class="row additional-info pb-3 py-4"
                    >
                      <div class="col-sm-12 col-md-4 col-lg-4">
                        <label>Razón:</label>
                        <p>
                          <b>{{ item.referralDenialReasonName }}</b>
                        </p>
                      </div>
                      <div class="col-sm-12 col-md-4 col-lg-4">
                        <label>Comentario:</label>
                        <p>
                          <b>{{ item.referralDeterminationComment }}</b>
                        </p>
                      </div>
                      <div class="col-sm-12 col-md-2 col-lg-2">
                        <label>Documento Anejado:</label>
                        <p v-if="item.documentId">
                          <CustomFileInput
                            ref="fileUpload"
                            class="w-100 text-left info"
                            display-style="normal"
                            :accept="'.pdf'"
                            :attachment-id="item.documentId"
                            :disabled="false"
                            :name="item.documentName"
                          />
                        </p>
                        <p v-else>-</p>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab
                lazy
                v-if="canShowAditionalInformation"
                :title="'Información adicional'"
              >
                <div class="additional-container">
                  <div class="row mx-auto px-3">
                    <div
                      class="col-12 detail-title py-3 d-flex flex-row justify-content-start align-items-center"
                    >
                      <i class="fas fa-info-circle text-orange" />
                      <b class="color-black">Información adicional</b>
                    </div>
                  </div>
                  <div class="row mx-auto px-2 mt-2">
                    <div class="col-sm-12 col-md-3 d-flex flex-column">
                      <div class="color-gray-6 font-14">Proveedor:</div>
                      <div class="color-black font-weight-bold">
                        {{ item.aditionalInformation.provideName }}
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-3 d-flex flex-column">
                      <div class="color-gray-6 font-14">Lugar de Servicio:</div>
                      <div class="color-black font-weight-bold">
                        {{ item.aditionalInformation.locationName }}
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-3 d-flex flex-column">
                      <div class="color-gray-6 font-14">Dirección:</div>
                      <div class="color-black font-weight-bold">
                        {{
                          item.aditionalInformation.locationAddresses
                            .addressLine1 || ''
                        }}
                        {{
                          item.aditionalInformation.locationAddresses
                            .addressLine2 || ''
                        }}
                        {{
                          item.aditionalInformation.locationAddresses
                            .addressLine3 || ''
                        }}
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-3 d-flex flex-column">
                      <div class="color-gray-6 font-14">Municipio:</div>
                      <div class="color-black font-weight-bold">
                        {{
                          item.aditionalInformation.locationAddresses
                            .municipalityName
                        }}
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-3 d-flex flex-column mt-3">
                      <div class="color-gray-6 font-14">Teléfono:</div>
                      <div class="color-black font-weight-bold">
                        {{ getPhoneMasked || '-' }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      item.referralStatusId ==
                        referralStatusEnum.Cita_Coordinada
                    "
                    class="row mx-auto px-3 mt-3"
                  >
                    <div
                      class="col-12 detail-title py-3 d-flex flex-row justify-content-start align-items-center px-3"
                    >
                      <i class="fas fa-info-circle text-orange" />
                      <b class="color-black">
                        Información de la Cita Coordinada
                      </b>
                    </div>
                  </div>
                  <div
                    v-if="
                      item.referralStatusId ==
                        referralStatusEnum.Cita_Coordinada
                    "
                    class="col-12 row mx-auto px-2 pb-3 mt-2"
                  >
                    <div class="col-sm-12 col-md-3 d-flex flex-column">
                      <div class="color-gray-6 font-14">Número de Cita:</div>
                      <div class="color-black font-weight-bold">
                        {{ item.clientAppointmentId }}
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-3 d-flex flex-column">
                      <div class="color-gray-6 font-14">Estatus:</div>
                      <div class="color-black font-weight-bold">
                        {{ item.appointmentStatusName }}
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-3 d-flex flex-column">
                      <div class="color-gray-6 font-14">Fecha:</div>
                      <div class="color-black font-weight-bold">
                        {{ item.appointment_TimeStart }}
                        {{ item.timeStartHours }} -
                        {{ item.timeEndHours }}
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-3 d-flex flex-column">
                      <div class="color-gray-6 font-14">
                        Cita coordinada por:
                      </div>
                      <div class="color-black font-weight-bold">
                        {{ item.coordinatedCreatedBy }}
                        <br />
                        {{ item.preReservationDate }}
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab
                ref="tabCanceledHistory"
                lazy
                v-if="item.appointmentCanceledCount > 0"
                :title="'Historial de Citas Canceladas'"
              >
                <canceled-appointment-history
                  :client-appointment-id="item.clientAppointmentId"
                />
              </b-tab>

              <BitacoraTabs
                ref="bitacoraTabs"
                :item="{
                  ...item,
                  requestNumberService: item.requestNumberRemPro,
                  status: item.serviceStatusDesc,
                  statusId: item.serviceStatusId,
                }"
                :commentTypes="commentTypes"
                :visible="!!item.requestServiceId && canShowBitacora"
                @save="handleSaveBlogItem"
                @cancel="toggleCallout"
              />
            </b-tabs>
          </div>
        </div>
      </template>
    </custom-callout>
    <custom-contact-info-modal
      :studentSieParam="item.studentSieId"
      ref="contactInfoModalRef"
      @save="saveModal"
    />
  </article>
</template>

<script>
import alert from '@/mixin/alert.mixin';
import CanceledAppointmentHistory from './CanceledAppointmentHistory.vue';

import CustomCallout from 'custom-callout';
import CustomBalloon from 'custom-balloon';
import Dropdown from 'dropdown';
import EvaluationReasons from '../EvaluationReasons';
import ReactivationForm from './ReactivationForm';
import RejectionReasonForm from './RejectionReasonForm.vue';
import CoordinateAppointment from './CoordinateAppointment';
import AttachDocument from '@/components/student/evaluationRequest/AttachDocument';

import reportService from '@/services/report';
import generalService from '@/services/pei/general';
import studentEvaluationService from '@/modules/student-evaluations/api';

import referralStatus from '@/utils/constants/pei/referral/referralStatus';
import contractStatuses from '@/utils/constants/contractStatuses';
import provisionalRemedyAnswerStatus from '@/utils/constants/student/provisionalRemedyAnswerStatus';
import rpStatuses from '@/utils/constants/rp/rpStatuses';
import disciplineTypes from '@/utils/constants/disciplineTypes.js';
import store from '@/store/index';
import pilotPlanRoles from '@/utils/constants/pilotPlanRoles.js';
import DocumentsService from '@/services/documents';
import { masker, tokens } from 'ke-the-mask';
import appointmentStatus from '@/utils/constants/appointmentStatus.js';
import BitacoraTabs from '@/components/bitacora-tabs/BitacoraTabs.vue';
import { addBlogItem } from '@/modules/referral/api';
import CustomFileInput from '@/components/common/CustomFileInput';
import CustomContactInfoModal from '@/components/common/CustomContactInfoModal';
import StudentService from '@/services/student';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';
const referralDenialReasons = Object.freeze({
  MaestroRemovioServicio: 19,
});

const Trianual = 4;
const Inicial = 2;
const Adicional = 1;
const Reevaluation = 3;

export default {
  name: 'ResultRow',
  mixins: [alert],
  components: {
    CustomCallout,
    CustomBalloon,
    Dropdown,
    RejectionReasonForm,
    ReactivationForm,
    EvaluationReasons,
    CoordinateAppointment,
    AttachDocument,
    BitacoraTabs,
    CustomFileInput,
    CustomContactInfoModal,
    CanceledAppointmentHistory,
  },
  data: () => ({
    isOpen: false,
    loaded: false,
    savedRequestId: null,
    referralStatusEnum: rpStatuses,
    reasonPanelId: null,
    attachDocumentPanelId: null,
    reasonPanelMode: -1,
    student: {},
    schoolInfo: {},
    isReactivation: false,
    isEditRejectReazon: false,
    activateCoordAvailSpaceVocational: false,
  }),
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    filterLocation: {
      type: Object,
      default: () => {},
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    commentTypes: {
      type: Array,
      default: () => [],
    },
  },
  async mounted() {
    await Promise.all([this.canActivateCoordAvailSpaceVocational()]);
  },
  computed: {
    canShowBitacora() {
      return this.$store.getters.HasPermission('academic.bitacora.tabs');
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    canShowAditionalInformation() {
      return [
        appointmentStatus.Coordinada,
        appointmentStatus.Completada,
        appointmentStatus.Confirmada,
        appointmentStatus.Cumplida,
        appointmentStatus.Coordinada,
      ].includes(this.item.appointmentStatusCd);
    },
    getPhoneMasked() {
      if (!this.item.aditionalInformation.telephone)
        return this.item.aditionalInformation.telephone;
      return masker(
        this.item.aditionalInformation.telephone,
        '(###)###-####',
        true,
        tokens
      );
    },
    actionItems() {
      return (item) => {
        let actions = [];
        if (
          item.referralDenialReasonId !=
          referralDenialReasons.MaestroRemovioServicio
        ) {
          actions = [
            {
              label: 'Anejar Documento',
              icon: 'fas fa-file-plus text-green',
              click: () => this.setAttachmentMode(item.studentReferralId),
              visible: this.showAttachDocumentOption(
                item.referralStatusId,
                item.canStatusBeNew
              ),
            },
          ];
        }

        const actionHistory = {
          label: 'Historial',
          icon: 'fas fa-history text-green',
          click: () => this.goToHistory(item.studentReferralId),
        };

        if (item.referralStatusId != this.referralStatusEnum.Denegado) {
          actions = [
            {
              label: 'Coordinar Cita',
              icon: 'fas fa-calendar-edit text-green',
              click: () => this.coordinateAppoinment(item),
              asLine: true,
              visible:
                this.canCoordinateAppointmentForVocationals(item) ||
                this.canCoordinateAppointmentForABA(item) ||
                this.showCoordinateAppointmentOption(item),
            },
            {
              label: 'Citas Canceladas',
              icon: 'far fa-calendar-times text-green',
              click: () => {
                this.toggleCallout();
                this.$nextTick(() => {
                  this.$refs.tabCanceledHistory?.activate();
                });
              },
              asLine: true,
              visible: this.item.appointmentCanceledCount > 0,
            },
            {
              label: ' Historial de Citas',
              icon: 'fas fa-history text-green',
              click: () =>
                this.goToAppointmentHistory(item.clientAppointmentId),
              visible: this.showAppointmentHistoryOption(item.referralStatusId),
            },
            {
              label: ' Hoja de Referido',
              icon: 'fas fa-download text-green',
              click: () => this.downloadReferralSheet(item.studentReferralId),
              visible: this.showReferralSheetOption(item),
            },
            {
              label: ' Aprobado',
              icon: 'fas fa-check-square text-green',
              click: () => this.setAproved(item.studentReferralId),
              visible: this.showApproveOption(item),
            },
            {
              label: 'Devuelto a Escuela',
              icon: 'fas fa-times-square text-red',
              click: () => this.setDenegate(item),
              visible: this.showDenegateOption(item.referralStatusId),
            },
            {
              label: ' Inactivo',
              icon: 'fas fa-minus-square',
              click: () => this.setInactive(item),
              visible: this.showInactiveOption(item.referralStatusId),
            },
            {
              label: ' Crear Solicitud de Remedio Provisional',
              icon: 'fas fa-plus-circle text-green',
              click: () => this.goToProvisionalRemedyRequest(item),
              visible: this.showProvisionalRemedyRequestOption(
                item.referralStatusId
              ),
            },
            {
              label: ' Descargar Solicitud',
              icon: 'fas fa-download text-green',
              click: () =>
                this.downloadProvissionalRemedyRequestReport(
                  item.requestNumberRemPro
                ),
              visible: this.showProvisionalApprovedOption(
                item.referralStatusId
              ),
            },
            {
              label: ' Descargar Carta de Aprobación',
              icon: 'fas fa-download text-green',
              click: () => this.downloadApprovalLetter(item.requestServiceId),
              visible: this.showProvisionalApprovedOption(
                item.referralStatusId
              ),
            },
            {
              label: 'Anejar Documento',
              icon: 'fas fa-file-plus text-green',
              click: () => this.setAttachmentMode(item.studentReferralId),
              visible: this.showAttachDocumentOption(
                item.referralStatusId,
                item.canStatusBeNew
              ),
            },
            {
              label: ' Descargar SAEE-12a',
              icon: 'fas fa-download text-green',
              click: () =>
                this.downloadVocationalEducationDocument(
                  item.saeE12ADocumentId
                ),
              visible: this.isVocationals(item.disciplineTypeId),
            },
            {
              label: ' Documentos de Respaldo',
              icon: 'fas fa-download text-green',
              click: () => this.supportDocumentDownload(item.studentReferralId),
              visible: this.showSupportDocument(item.disciplineTypeId),
            },
            actionHistory,
            {
              label: 'Actualizar Contacto',
              icon: 'fas fa-user-edit text-green',
              click: async () => await this.$refs.contactInfoModalRef.open(),
              visible: this.userHasPermissions('academic.parentcontact.update'),
            },
            {
              label: 'Bitácora de Seguimiento',
              icon: 'fas fa-file-signature text-green',
              click: () => this.showBitacoraTab(),
              visible: () => {
                return (
                  !!item.requestServiceId &&
                  this.canShowBitacora &&
                  item.referralStatusId ===
                    this.referralStatusEnum.AprobadoEnRempro
                );
              },
            },
            {
              label: 'Reactivar Referido',
              icon: 'fas fa-repeat-alt text-green',
              click: () => this.showReactivateTab(item),
              visible: () => {
                return (
                  item.referralStatusId == this.referralStatusEnum.Inactivo &&
                  this.hasPermission('academic.referralreactivation')
                );
              },
            },
            {
              label: 'Editar Razón de Rechazo',
              icon: 'fas fa-repeat-alt text-green',
              click: () => this.showEditRejectReazonTab(item),
              visible: () => {
                return (
                  item.referralStatusId == this.referralStatusEnum.Inactivo &&
                  this.hasPermission('academic.editreferralrejectreazon')
                );
              },
            },
          ];
        }
        if (item.referralStatusId == this.referralStatusEnum.Denegado) {
          actions = [
            {
              label: 'Anejar Documento',
              icon: 'fas fa-file-plus text-green',
              click: () => this.setAttachmentMode(item.studentReferralId),
            },
            {
              label: ' Inactivo',
              icon: 'fas fa-minus-square',
              click: () => this.setInactive(item),
            },
            {
              label: 'Entrar',
              icon: 'fas fa-file-plus text-green',
              click: () => this.goToAddEditEvaluation(item),
            },
            {
              label: ' Hoja de Referido',
              icon: 'fas fa-download text-green',
              click: () => this.downloadReferralSheet(item.studentReferralId),
              visible: this.showReferralSheetOption(item),
            },
            actionHistory,
          ];
        }
        return actions;
      };
    },
    userPilotPlan() {
      return store.getters['$_user/pilotPlan'];
    },
    userRole() {
      return store.getters['$_user/role'];
    },
    isVocationalEducation() {
      return this.item.disciplineTypeId === disciplineTypes.EducacionVocacional;
    },
    isAnyVocational() {
      const vocationalTypes = [
        disciplineTypes.EducacionVocacional,
        disciplineTypes.EducacionVocacionalPreliminar,
        disciplineTypes.EvaluacionVocacionalFinal,
      ];

      return vocationalTypes.includes(this.item.disciplineTypeId);
    },
    isABA() {
      return this.item.disciplineTypeId === disciplineTypes.ABA;
    },
    canShowOptionForVocational() {
      return (
        this.isAnyVocational &&
        this.hasPermission(
          'evaluationcoordination.appointment.vocationaleducation'
        )
      );
    },
    canShowOptionForABA() {
      return (
        this.isABA &&
        this.hasPermission(
          'evaluationcoordination.appointment.coordinateappointment.aba'
        )
      );
    },
    canShowOptionForDiscipline() {
      return (
        (!this.isABA && !this.isAnyVocational) ||
        this.canShowOptionForVocational ||
        this.canShowOptionForABA
      );
    },
    hasCustomAdditionalInformation() {
      return (referralStatusId) =>
        [
          this.referralStatusEnum.AprobadoEnRempro,
          this.referralStatusEnum.Inactivo,
          this.referralStatusEnum.Denegado,
        ].includes(referralStatusId);
    },
  },
  methods: {
    async saveModal(params) {
      let contactInfo = {
        contactName: params.contactname,
        contacteMail: params.contactemail,
        emailSuppliedFlag: params.emailsuppliedflag,
        contactTelephone: params.contacttelephone,
        contactTelephoneProviderCode: params.contacttelephoneprovidercode,
        regStudentId: params.regstudentid,
        contactRelation: params.contactrelation,
        receiveMessageTextFlag: params.receiveMessageTextFlag,
      };
      await StudentService.updateStudentContactInformation(contactInfo);
      await this.getContactInformation();
    },
    async showBitacoraTab() {
      await this.toggleCallout();
      if (this.isOpen) {
        this.$refs.bitacoraTabs.$refs.bitacoraTab.activate();
      }
    },
    async getSchoolInformation() {
      let self = this;
      await self
        .$ApiGet(
          `api/studentreferrals/referralInterventionLevelAsync/${this.item.studentReferralId}`
        )
        .then((res) => {
          if (res.data) {
            const data = res.data;
            this.schoolInfo = data;
          }
        });
    },
    openCallout() {
      this.toggleCallout();
    },
    async getContactInformation() {
      let self = this;
      await self
        .$ApiGet(`/api/student/${this.item.studentSieId}/ContactInformation`)
        .then((res) => {
          if (res.data) {
            const data = res.data;
            this.student = data;
          }
        });
    },
    async toggleCallout() {
      this.isOpen = !this.isOpen;
      if (this.isOpen && !this.isReactivation && !this.isEditRejectReazon) {
        this.getContactInformation();
        this.getSchoolInformation();
      }
      if (!this.isOpen || this.loaded) return;
      this.loaded = this.isOpen;
    },
    onCancelReferalPanel() {
      this.reasonPanelId = null;
      this.reasonPanelMode = -1;
      this.attachDocumentPanelId = null;

      this.toggleCallout();
    },
    onCancelCoordinateAppointmentPanel(item) {
      item.showCoordinateAppointment = false;

      this.toggleCallout();
    },
    async onChangeStudentStatus() {
      this.$emit('getStudentEvaluationRequests', {
        currentPage: this.currentPage,
      });
    },
    onSaveCoordinateAppointment(item, appointment) {
      this.onCancelCoordinateAppointmentPanel(item);
      item.referralStatusName = appointment.referralStatusName;
      item.referralStatusId = appointment.referralStatusId;
      item.clientAppointmentId = appointment.clientAppointmentId;
      item.appointmentStatusName = appointment.appoitmentStatusName;
      item.appointment_TimeStart = appointment.timeStart;
      item.appointment_TimeEnd = appointment.timeEnd;
      item.coordinatedCreatedBy = appointment.coordinatedCreatedBy;
    },
    getStatusColor(referralStatusId) {
      switch (referralStatusId) {
        case this.referralStatusEnum.Nuevo:
          return 'pink';
        case this.referralStatusEnum.Cita_Coordinada:
          return 'green-light';
        case this.referralStatusEnum.Denegado:
          return 'brown';
        case this.referralStatusEnum.Procesado:
          return 'green-light';
        case this.referralStatusEnum.Aprobado:
        case this.referralStatusEnum.AprobadoDevueltoREMPRO:
          return 'yellow';
        case this.referralStatusEnum.ReCoordinar_Cita:
          return 'yellow';
        case this.referralStatusEnum.Referido_a_Remedio_Provisional:
          return 'violet';
        case this.referralStatusEnum.Inactivo:
          return 'brown';
        case this.referralStatusEnum.AprobadoEnRempro:
          return 'violet';
        case this.referralStatusEnum.No_Vinculado_Devuelto_RemPro:
          return 'pink';
      }
      return 'gray';
    },
    showCoordinateAppointmentOption(item) {
      const statusesAllowed = [
        referralStatus.approved,
        referralStatus.recoordinated,
      ];

      // If the discipline is vocational or ABA, exit the function because there are other functions to handle these disciplines.
      if (
        this.isVocationals(item.disciplineTypeId) ||
        item.disciplineTypeId === disciplineTypes.ABA
      ) {
        return false;
      }

      var result =
        statusesAllowed.includes(item.referralStatusId) &&
        (this.hasPermission(
          'evaluationcoordination.appointment.coordinateappointment'
        ) ||
          this.hasPermission(
            'evaluationcoordination.appointment.adaptedphysicaleducation'
          ));

      // if pilot plan, hide if not in plan or if in plan but cannot show
      if (this.shouldHideByPilotPlan(result)) {
        return false;
      }

      return result;
    },
    canCoordinateAppointmentForABA(item) {
      const statusesAllowed = [
        referralStatus.approved,
        referralStatus.recoordinated,
      ];

      const isABA = item.disciplineTypeId === disciplineTypes.ABA;
      let canShow =
        isABA &&
        statusesAllowed.includes(item.referralStatusId) &&
        this.hasPermission(
          'evaluationcoordination.appointment.coordinateappointment.aba'
        );

      // if pilot plan, hide if not in plan or if in plan but cannot show
      if (this.shouldHideByPilotPlan(canShow)) {
        return false;
      }

      return canShow;
    },
    canCoordinateAppointmentForVocationals(item) {
      const statusesAllowed = [
        referralStatus.approved,
        referralStatus.recoordinated,
      ];

      let canShow =
        this.isVocationals(item.disciplineTypeId) &&
        statusesAllowed.includes(item.referralStatusId) &&
        this.hasPermission(
          'evaluationcoordination.appointment.vocationaleducation'
        );

      // if pilot plan, hide if not in plan or if in plan but cannot show
      if (this.shouldHideByPilotPlan(canShow)) {
        return false;
      }

      return canShow;
    },
    /**
     * Aplica las reglas de visibilidad del plan piloto.
     * @param {boolean} canShow - Si la opción cumple condiciones (estado, permisos, etc.)
     * @returns {boolean} - false si debe ocultarse por plan piloto; si no, canShow
     */
    shouldHideByPilotPlan(canShow = true) {
      const hasPilotRoleButNotInPlan =
        pilotPlanRoles.includes(this.userRole) && !this.userPilotPlan;
      const isInPlanButCannotShow = this.userPilotPlan && !canShow;

      if (hasPilotRoleButNotInPlan || isInPlanButCannotShow) {
        return true; // ocultar
      }
      return false;
    },
    showAppointmentHistoryOption(referralStatusId) {
      const statusesAllowed = [this.referralStatusEnum.ReCoordinar_Cita];

      return statusesAllowed.includes(referralStatusId);
    },
    showProvisionalApprovedOption(referralStatusId) {
      const statusesAllowed = [this.referralStatusEnum.AprobadoEnRempro];

      return statusesAllowed.includes(referralStatusId);
    },
    isVocationals(disciplineTypeId) {
      const vocationals = [
        disciplineTypes.EducacionVocacional,
        disciplineTypes.EvaluacionVocacionalPreliminar,
        disciplineTypes.EvaluacionVocacionalFinal,
      ];
      return vocationals.includes(disciplineTypeId);
    },
    showSupportDocument(disciplineTypeId) {
      return [disciplineTypes.ABA, disciplineTypes.FisicaAdaptada].includes(
        disciplineTypeId
      );
    },
    showReferralSheetOption(item) {
      const statusesAllowed = [
        this.referralStatusEnum.Nuevo_y_ReCoordinar_Cita,
        this.referralStatusEnum.Nuevo,
        this.referralStatusEnum.Aprobado,
        this.referralStatusEnum.AprobadoDevueltoREMPRO,
        this.referralStatusEnum.Cita_Coordinada,
        this.referralStatusEnum.ReCoordinar_Cita,
        this.referralStatusEnum.AprobadoEnRempro,
        this.referralStatusEnum.Cancelado,
      ];

      return (
        item.studentSieId != null &&
        statusesAllowed.includes(item.referralStatusId)
      );
    },
    showApproveOption(row) {
      if (!this.hasPermission('evaluationcoordination.appointment.approve')) {
        return false;
      }

      // if pilot plan, hide if not in plan or if in plan but cannot show
      if (this.shouldHideByPilotPlan()) {
        return false;
      }

      // if the discipline is not allowed, return false
      if (!this.canShowOptionForDiscipline) {
        return false;
      }

      if (
        row.referralStatusId == this.referralStatusEnum.Nuevo ||
        row.referralStatusId ==
          this.referralStatusEnum.No_Vinculado_Devuelto_RemPro ||
        row.referralStatusId == this.referralStatusEnum.AprobadoDevueltoREMPRO
      ) {
        return true;
      } else if (
        row.referralStatusId ==
        this.referralStatusEnum.Referido_a_Remedio_Provisional
      ) {
        return true;
      } else if (
        row.referralStatusId == this.referralStatusEnum.AprobadoEnRempro &&
        (row.serviceStatusId == provisionalRemedyAnswerStatus.Cancelado ||
          row.serviceStatusId == provisionalRemedyAnswerStatus.Objetado)
      ) {
        return (
          row.contractStatusId == undefined ||
          row.contractStatusId == contractStatuses.ContratoCancelado
        );
      }
      return false;
    },
    showDenegateOption(referralStatusId) {
      const statusesAllowed = [
        this.referralStatusEnum.Nuevo,
        this.referralStatusEnum.Aprobado,
        this.referralStatusEnum.AprobadoDevueltoREMPRO,
        this.referralStatusEnum.AprobadoEnRempro,
        this.referralStatusEnum.ReCoordinar_Cita,
        this.referralStatusEnum.Referido_a_Remedio_Provisional,
        this.referralStatusEnum.No_Vinculado_Devuelto_RemPro,
      ];
      if (!this.hasPermission('evaluationcoordination.appointment.deny')) {
        return false;
      }
      if (pilotPlanRoles.includes(this.userRole) && !this.userPilotPlan) {
        return false;
      }

      return (
        statusesAllowed.includes(referralStatusId) &&
        this.canShowOptionForDiscipline
      );
    },
    showInactiveOption(referralStatusId) {
      const statusesAllowed = [
        this.referralStatusEnum.Nuevo,
        this.referralStatusEnum.Aprobado,
        this.referralStatusEnum.AprobadoDevueltoREMPRO,
        this.referralStatusEnum.AprobadoEnRempro,
        this.referralStatusEnum.ReCoordinar_Cita,
        this.referralStatusEnum.Referido_a_Remedio_Provisional,
        this.referralStatusEnum.No_Vinculado_Devuelto_RemPro,
      ];
      if (
        !this.hasPermission('evaluationcoordination.appointment.inactivate')
      ) {
        return false;
      }
      if (pilotPlanRoles.includes(this.userRole) && !this.userPilotPlan) {
        return false;
      }
      return statusesAllowed.includes(referralStatusId);
    },
    showProvisionalRemedyRequestOption(referralStatusId) {
      const statusesAllowed = [
        this.referralStatusEnum.Nuevo,
        this.referralStatusEnum.Aprobado,
        this.referralStatusEnum.AprobadoDevueltoREMPRO,
        this.referralStatusEnum.ReCoordinar_Cita,
        this.referralStatusEnum.No_Vinculado_Devuelto_RemPro,
      ];

      const disciplinesExcluded = [disciplineTypes.FisicaAdaptada];

      return (
        statusesAllowed.includes(referralStatusId) &&
        !disciplinesExcluded.includes(this.item.disciplineTypeId) &&
        this.hasPermission('evaluation.remedy') &&
        this.canShowOptionForDiscipline
      );
    },
    showAttachDocumentOption(referralStatusId, canStatusBeNew) {
      const statusesAllowed = [
        this.referralStatusEnum.Denegado,
        this.referralStatusEnum.Inactivo,
      ];
      if (pilotPlanRoles.includes(this.userRole) && !this.userPilotPlan) {
        return false;
      }
      return statusesAllowed.includes(referralStatusId) && canStatusBeNew;
    },
    hasPermission(permission) {
      return this.$store.getters.HasPermission(permission);
    },
    hasAditionalInformation(referralStatusId) {
      return (
        referralStatusId == this.referralStatusEnum.AprobadoEnRempro ||
        referralStatusId == this.referralStatusEnum.Inactivo ||
        referralStatusId == this.referralStatusEnum.Denegado ||
        referralStatusId == this.referralStatusEnum.Cita_Coordinada
      );
    },
    getAdditionalInfoTitle(referralStatusId) {
      switch (referralStatusId) {
        case this.referralStatusEnum.AprobadoEnRempro:
          return 'Información del Servicio en Remedio Provisional';
        case this.referralStatusEnum.Inactivo:
          return 'Información de Inactivación';
        case this.referralStatusEnum.Denegado:
          return 'Información de Devuelto a la Escuela';
        default:
          return null;
      }
    },

    goToAddEditEvaluation(item) {
      if (item.evaluationTypeId == Trianual) {
        this.$router.push({
          path: `/student/ProcessDeterminationTriannualView/${item.evaluationDateId}`,
          query: {
            isSubmitted: false,
            isFromDetermination: false,
            isFromDetailCoordination: true,
            studentSieId: item.studentSieId,
          },
        });
      } else if (
        item.evaluationTypeId == Adicional ||
        item.evaluationTypeId == Inicial ||
        item.evaluationTypeId == Reevaluation
      ) {
        this.$router.push({
          path: '/student/EditEvaluations',
          query: item,
        });
      }
    },
    coordinateAppoinment(item) {
      this.$emit('persistCoordinateAppoinmentData', item);
      if (this.activateCoordAvailSpaceVocational) {
        this.$router.push({
          name: 'AppoinmentCoordinationEval',
        });
      } else {
        if (
          [
            disciplineTypes.FisicaAdaptada,
            disciplineTypes.EducacionVocacional,
            disciplineTypes.EducacionVocacionalPreliminar,
            disciplineTypes.EducacionVocacionalFinal,
          ].includes(item.disciplineTypeId)
        ) {
          item.showCoordinateAppointment = true;
          this.toggleCallout();
        } else {
          this.$router.push({
            name: 'AppoinmentCoordinationEval',
          });
        }
      }
    },
    goToAppointmentHistory(clientAppointmentId) {
      this.$router.push({
        name: 'EvaluationAppointmentHistorical',
        params: { client: clientAppointmentId },
      });
    },
    goToProvisionalRemedyRequest(item) {
      let self = this;
      self
        .$ApiGet(
          `/api/studentevaluation/checkprovisionalremedyrequest/${item.studentSieId}/${item.disciplineTypeId}`
        )
        .then((res) => {
          if (res.data != null && res.data != '') {
            self.savedRequestId = res.data.id;
            this.ShowCancelModal(
              'Confirmación',
              `Se encontró un servicio activo en Remedio Provisional para la misma disciplina del referido bajo la(s) solicitud(es) ${res.data.requestNumber} ¿Desea identificar este referido como Aprobado en Remedio Provisional utilizando la solicitud encontrada?`,
              'Sí',
              'No'
            ).then((response) => {
              if (response) {
                self
                  .$ApiPost(
                    `/api/studentevaluation/approveprovisionalremedyrequest/${item.studentReferralId}/${self.savedRequestId}`
                  )
                  .then(() => {
                    this.$emit(
                      'getStudentEvaluationRequests',
                      { currentPage: 1 },
                      true
                    );
                  });
              } else {
                this.pushPageProvisionalRemedyRequest(item);
              }
            });
          } else {
            this.pushPageProvisionalRemedyRequest(item);
          }
        })
        .catch((err) => {
          self.ShowToast('', err.message, 'error');
        });
    },
    async pushPageProvisionalRemedyRequest(item) {
      let provisionalRemedyRequest = {
        name: item.studentFullName,
        sie: item.studentSieId,
        evaluationType: item.evaluationTypeName,
        discipline: item.disciplineTypeName,
        applicationDate: item.requestDate,
        studentReferralId: item.studentReferralId,
        AcademicYearId: item.academicYearId,
        thrpyDisciplineTypeId: item.disciplineTypeId,
        thrpyTherapyDurationId: item.therapyDurationId,
        thrpyFrequencyTypeId: item.frequencyTypeId,
        thrpyModalityTypeId: item.modalityTypeId,
        thrpyReferralDate: item.referralDate,
        thrpyAdmissionId: item.admissionId,
        isThrpy: false,
      };

      this.$store.dispatch(
        'setProvisionalRemedyRequest',
        provisionalRemedyRequest
      );

      this.$router.push({
        name: `student-provisionalRemedyRequest`,
      });
    },
    downloadReferralSheet(studentReferralId) {
      reportService.downloadReferralReport(studentReferralId);
    },
    downloadProvissionalRemedyRequestReport(requestNumberRemPro) {
      let self = this;
      self
        .$ApiGet(
          `/api/studentevaluation/requestreportdownload?requestNumber=${requestNumberRemPro}`
        )
        .then((res) => {
          generalService.documentDownloadReport(
            res.data.content,
            res.data.filename
          );
        })
        .catch((err) => {
          self.response = err.data.message;
        });
    },
    async downloadVocationalEducationDocument(documentId) {
      if (!documentId) {
        this.ShowToast('Error', 'El documento no existe.', 'error');
        return;
      }
      await DocumentsService.downloadFromServer(documentId).catch((err) => {
        const errorMsg =
          err.data && err.data.message
            ? err.data.message
            : err.response.data.message;
        this.ShowToast('Error', errorMsg, 'error');
      });
    },
    async supportDocumentDownload(studentReferralId) {
      await studentEvaluationService
        .supportDocumentDownload(studentReferralId)
        .catch((err) => {
          const errorMsg =
            err.data && err.data.message
              ? err.data.message
              : err.response.data.message;
          this.ShowToast('Error', errorMsg, 'error');
        });
    },
    async downloadApprovalLetter(requestServiceId) {
      await studentEvaluationService
        .approvalLetterDownload(requestServiceId)
        .catch((err) => {
          const errorMsg =
            err.data && err.data.message
              ? err.data.message
              : err.response.data.message;
          this.ShowToast('Error', errorMsg, 'error');
        });
    },
    setAproved(studentReferralId) {
      this.reasonPanelMode = this.referralStatusEnum.Aprobado;
      this.reasonPanelId = studentReferralId;
      this.toggleCallout();
    },
    setDenegate(item) {
      if (this.studentIsActiveInRempro(item)) return false;

      this.reasonPanelMode = this.referralStatusEnum.Denegado;
      this.reasonPanelId = item.studentReferralId;
      this.toggleCallout();
    },
    setInactive(item) {
      if (this.studentIsActiveInRempro(item)) return false;

      this.reasonPanelMode = this.referralStatusEnum.Inactivo;
      this.reasonPanelId = item.studentReferralId;
      this.toggleCallout();
    },
    showEditRejectReazonTab(item) {
      this.isReactivation = false;
      this.isEditRejectReazon = true;
      this.reasonPanelId = item.studentReferralId;
      this.toggleCallout();
    },
    handleCancelEditRejectReazon() {
      this.isEditRejectReazon = false;
      this.reasonPanelId = null;
      this.toggleCallout();
    },
    async handleEditRejectReazon(formData) {
      try {
        await this.$ApiPost(
          `api/studentevaluation/saveReferralStatusReason`,
          formData
        );

        this.isEditRejectReazon = false;
        this.reasonPanelId = null;
        this.toggleCallout();

        this.ShowToast(
          '',
          'Razón de Rechazo Actualizada Exitosamente.',
          'success'
        );
        this.onChangeStudentStatus();
      } catch (err) {
        const message =
          err?.response?.data?.message ?? 'Ocurrió un error inesperado.';
        this.ShowToast('', message, 'error');
      }
    },
    showReactivateTab(item) {
      this.isReactivation = true;
      this.isEditRejectReazon = false;
      this.reasonPanelId = item.studentReferralId;
      this.toggleCallout();
    },
    handleCancelReactivate() {
      this.isReactivation = false;
      this.reasonPanelId = null;
      this.toggleCallout();
    },
    async handleReactivate(comment) {
      const payload = {
        id: this.reasonPanelId,
        comment: comment,
      };

      try {
        await this.$ApiPut(`/api/student/reactivatereferral`, payload);

        this.isReactivation = false;
        this.reasonPanelId = null;
        this.toggleCallout();

        this.ShowToast('', 'Referido Reactivado Exitosamente.', 'success');

        this.onChangeStudentStatus();
      } catch (err) {
        const message =
          err?.response?.data?.message ?? 'Ocurrió un error inesperado.';
        this.ShowToast('', message, 'error');
      }
    },
    setAttachmentMode(studentReferralId) {
      this.reasonPanelMode = this.referralStatusEnum.Nuevo;
      this.attachDocumentPanelId = studentReferralId;
      this.toggleCallout();
    },
    studentIsActiveInRempro(item) {
      if (item.referralStatusId == this.referralStatusEnum.AprobadoEnRempro) {
        const errorMsg = this.getMessage('0709').replace(
          '{###}',
          item.requestNumberRemPro
        );

        if (
          item.serviceStatusId != provisionalRemedyAnswerStatus.Cancelado &&
          item.serviceStatusId != provisionalRemedyAnswerStatus.Objetado
        ) {
          this.ShowToast('Alerta', errorMsg, 'error');
          return true;
        }

        if (item.contractStatusId) {
          if (item.contractStatusId != contractStatuses.ContratoCancelado) {
            this.ShowToast('Alerta', errorMsg, 'error');
            return true;
          }
        }

        return false;
      }
    },
    async handleSaveBlogItem(data) {
      try {
        const formData = new FormData();
        formData.append('comment', data.comment);
        formData.append('commentTypeId', data.commentTypeId);
        formData.append('fileAlias', data.fileAlias);
        formData.append('file', data.file);

        await addBlogItem(data.requestServiceId, formData);
        this.ShowToast(
          '',
          'Elemento agregado a la bitácora correctamente.',
          'success'
        );
      } catch (err) {
        this.ShowToast(
          'Alerta',
          'Ocurrió un error al agregar un nuevo elemento a la bitácora',
          'error'
        );
      }
      await this.toggleCallout();
    },
    goToHistory(studentReferralId) {
      this.$router.push({
        path: `/student/evaluationrequestmanagement/history/${studentReferralId}`,
      });
    },
    async canActivateCoordAvailSpaceVocational() {
      const { data } = await getSysparameterByNames({
        parameterNames: ['ActivateCoordAvailSpaceVocational'],
      });

      this.activateCoordAvailSpaceVocational =
        data
          ?.find((x) => x.name == 'ActivateCoordAvailSpaceVocational')
          ?.staticValue?.toLowerCase() == 'true' ?? false;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables/_colors.scss';

.main-content {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  opacity: 1;
}
.btn-detail {
  color: #2db782;
  cursor: pointer;
}
.btn-detail-closed {
  color: #3f5b60;
  cursor: pointer;
}
.bg-white {
  background-color: white;
}
.top-radius {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.bottom-radius {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.bg-lightgray {
  background-color: #f2f2f2;
}
.detail-title {
  color: #5f5f5f;
}

.detail-title i {
  float: left;
  margin-right: 10px;
}

.detail-title b {
  float: left;
}
.detailBoxColor {
  background-color: #f2f2f2;
}
div .bottom-divider {
  border-bottom: 1px solid lightgray;
  border-bottom-width: thin;
}

.div-divider {
  border-top: 1px solid #cacdcf;
}

/* Status */
/************ CUSTOM BADGES *************/
.border-right-2 {
  border-right: 1px solid rgba(114, 114, 114, 0.22);
}
.badges {
  color: black;
  font-size: 16px;
  width: 80%;
  line-height: 20px;
  border-radius: 20px;
  padding: 10px;
  font-size: 18px;
}
.badge-new {
  background: #fcc9c8;
}
.badge-coordinated {
  background: #a4e5b2;
}
.badge-denied {
  background: #d5b899;
}
.badge-processed {
  background: #a4e5b2;
}
.badge-aproved {
  background: #f8ea80;
}
.badge-reCordinate {
  background: #f8ea80;
}
.badge-referedRemPro {
  background: #ddb3d7;
}
.badge-inactive {
  background: #d5b899;
}
.badge-aprovedRemPro {
  background: #ac99c1;
}
.short-width {
  max-width: 3%;
}

/* Table */
/* Table */
#searchLocationContainer {
  td,
  th,
  tr {
    text-align: left;
  }
  ::v-deep .vgt-searchLocation {
    thead th {
      border-top: none;
      font-weight: bold;
    }
    th {
      text-align: center;
      border-bottom: none !important;
    }
    td {
      padding: 1em 10px;
      vertical-align: top;
      text-align: left;
      font: 1rem 'Lato';
      letter-spacing: 0;
      color: #11291b;
      padding-bottom: 0;
      border-top: none !important;
    }
  }
  ::v-deep div.vgt-responsive {
    overflow-x: visible;
  }
}
.grey-border {
  border-bottom: 1px #cacdcf solid !important;
}

.custom-separator-title {
  margin-top: 35px;
}

.custom-row-information {
  float: left;
  width: 26%;
  margin-top: 20px;
  padding-left: 15px;
}

.custom-row-information b {
  font-size: 14px;
}

.custom-row-information .first-row {
  padding-bottom: 20px;
}

.custom-row-information-command {
  float: right;
  width: 18%;
  margin-top: 20px;
  padding-right: 5px;
}

.custom-row-services {
  float: left;
  margin-left: 10px;
  margin-top: 30px;
}

.custom-row-services a {
  margin-top: 10px;
  float: left;
  font-size: 10px;
  width: 100%;
}

.custom-row-services b {
  float: left;
  width: 100%;
}

.custom-row {
  background-color: #f7f7f7;
  padding-bottom: 20px;
  border-left-width: 5px;
  border-left-style: solid;
  border-radius: 5px;
}

.custom-row .border-separator {
  border-right-width: 2px;
  border-right-style: solid;
  border-right-color: #6c757d24;
  /* border-top: 16px;     */
  /* top: 10px; */
}

.custom-row-information-collapse {
  border: #f7f7f7;
}

.custom-row-information-collapse-panel {
  float: left;
  margin-left: 25px;
}

.additional-info {
  padding-left: 54px;
}
label {
  color: gray;
}

.color-black {
  color: map-get($colors, 'black');
}

@media only screen and (max-width: 768px) {
  ::v-deep .tag-badge {
    padding-left: 0px;
    height: auto !important;
    .tag-badge-title {
      font-size: 16px;
    }
  }

  .nav-text {
    margin-top: 20px !important;
    margin-left: 17px;
  }

  .custom-row-information-collapse {
    .additional-info {
      padding-left: 11px !important;
    }
  }
}
</style>
<style lang="scss" scoped>
@use "sass:map";
@import '@/assets/scss/variables/_colors.scss';

::v-deep .custom-nav-container {
  border-bottom: 1px solid map-get($colors, 'gray-5');
  margin-left: 20px;
  margin-right: 20px;
  .nav-item {
    .nav-link {
      font-size: 16px !important;
      padding-right: 100px;
      color: map-get($colors, 'gray-6');
      padding-left: 100px;
      &.active {
        border-bottom: 3px solid map-get($colors, 'green');
        color: map-get($colors, 'green');
        font-weight: bold;
      }
      &.active:after {
        content: unset;
      }
    }
  }
}
</style>
